"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadActiveChallenges = loadActiveChallenges;
exports.loadCurrentChallenges = loadCurrentChallenges;
exports.loadNextChallenges = loadNextChallenges;
exports.loadFinishedChallenges = loadFinishedChallenges;
exports.loadRegisteredCurrentChallenges = loadRegisteredCurrentChallenges;
exports.loadRegisteredFinishedChallenges = loadRegisteredFinishedChallenges;
exports.loadPromoteChallenges = loadPromoteChallenges;
exports.watchLoadActiveChallenges = watchLoadActiveChallenges;
exports.watchLoadCurrentChallenges = watchLoadCurrentChallenges;
exports.watchLoadNextChallenges = watchLoadNextChallenges;
exports.watchLoadFinishedChallenges = watchLoadFinishedChallenges;
exports.watchLoadRegisteredCurrentChallenges = watchLoadRegisteredCurrentChallenges;
exports.watchLoadRegisteredFinishedChallenges = watchLoadRegisteredFinishedChallenges;
exports.watchLoadPromoteChallenges = watchLoadPromoteChallenges;
exports["default"] = exports.challengesSagas = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _utils = require("../../utils");

var _actions = _interopRequireDefault(require("./actions"));

var _constants = require("./constants");

var _olyEngineUtils = require("@sportheroes/oly-engine-utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _marked = _regenerator["default"].mark(gatherChallengeList),
    _marked2 = _regenerator["default"].mark(loadActiveChallenges),
    _marked3 = _regenerator["default"].mark(loadCurrentChallenges),
    _marked4 = _regenerator["default"].mark(loadNextChallenges),
    _marked5 = _regenerator["default"].mark(loadFinishedChallenges),
    _marked6 = _regenerator["default"].mark(loadRegisteredCurrentChallenges),
    _marked7 = _regenerator["default"].mark(loadRegisteredFinishedChallenges),
    _marked8 = _regenerator["default"].mark(loadPromoteChallenges),
    _marked9 = _regenerator["default"].mark(watchLoadActiveChallenges),
    _marked10 = _regenerator["default"].mark(watchLoadCurrentChallenges),
    _marked11 = _regenerator["default"].mark(watchLoadNextChallenges),
    _marked12 = _regenerator["default"].mark(watchLoadFinishedChallenges),
    _marked13 = _regenerator["default"].mark(watchLoadRegisteredCurrentChallenges),
    _marked14 = _regenerator["default"].mark(watchLoadRegisteredFinishedChallenges),
    _marked15 = _regenerator["default"].mark(watchLoadPromoteChallenges);

function gatherChallengeList(_ref) {
  var apis, clientId, status, _ref$skip, skip, _ref$limit, limit, search, results, _results, _results$meta, meta, nextItems;

  return _regenerator["default"].wrap(function gatherChallengeList$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          apis = _ref.apis, clientId = _ref.clientId, status = _ref.status, _ref$skip = _ref.skip, skip = _ref$skip === void 0 ? 0 : _ref$skip, _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? 20 : _ref$limit, search = _ref.search;
          _context.next = 3;
          return apis.challengeApi.getChallengesList({
            clientId: clientId,
            status: status,
            skip: skip,
            limit: limit,
            search: search
          }).then(function (p) {
            return p.request;
          });

        case 3:
          results = _context.sent;
          _results = results, _results$meta = _results.meta, meta = _results$meta === void 0 ? null : _results$meta;

          if (!(meta && meta.count === 0 && meta.hasNext)) {
            _context.next = 10;
            break;
          }

          nextItems = skip + limit;
          _context.next = 9;
          return apis.challengeApi.getChallengesList({
            clientId: clientId,
            status: status,
            skip: nextItems,
            limit: limit,
            search: search
          }).then(function (p) {
            return p.request;
          });

        case 9:
          results = _context.sent;

        case 10:
          return _context.abrupt("return", results);

        case 11:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function loadActiveChallenges(apis, action) {
  var _action$payload, clientId, _action$payload$skip, skip, _action$payload$limit, limit, language, defaultLanguage, search, _yield$gatherChalleng, data, meta, convertedData;

  return _regenerator["default"].wrap(function loadActiveChallenges$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _action$payload = action.payload, clientId = _action$payload.clientId, _action$payload$skip = _action$payload.skip, skip = _action$payload$skip === void 0 ? 0 : _action$payload$skip, _action$payload$limit = _action$payload.limit, limit = _action$payload$limit === void 0 ? _constants.PER_PAGE_CHALLENGES_LIST : _action$payload$limit, language = _action$payload.language, defaultLanguage = _action$payload.defaultLanguage, search = _action$payload.search;
          _context2.prev = 1;
          _context2.next = 4;
          return gatherChallengeList({
            apis: apis,
            clientId: clientId,
            status: 'active',
            skip: skip,
            limit: limit,
            search: search
          });

        case 4:
          _yield$gatherChalleng = _context2.sent;
          data = _yield$gatherChalleng.data;
          meta = _yield$gatherChalleng.meta;
          convertedData = data.map(function (item) {
            if (item.display) {
              return _objectSpread({}, item, {
                display: _olyEngineUtils.displayUtils.getDisplayObjectValues({
                  display: item.display,
                  language: language,
                  defaultLanguage: defaultLanguage
                })
              });
            }

            return item;
          });
          _context2.next = 10;
          return (0, _effects.put)(_actions["default"].loadActiveChallengesSuccess({
            data: convertedData,
            meta: meta
          }));

        case 10:
          _context2.next = 16;
          break;

        case 12:
          _context2.prev = 12;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 16;
          return (0, _effects.put)(_actions["default"].loadActiveChallengesError(true));

        case 16:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 12]]);
}

function loadCurrentChallenges(apis, action) {
  var _action$payload2, clientId, _action$payload2$skip, skip, _action$payload2$limi, limit, language, defaultLanguage, search, _yield$gatherChalleng2, data, meta, convertedData;

  return _regenerator["default"].wrap(function loadCurrentChallenges$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _action$payload2 = action.payload, clientId = _action$payload2.clientId, _action$payload2$skip = _action$payload2.skip, skip = _action$payload2$skip === void 0 ? 0 : _action$payload2$skip, _action$payload2$limi = _action$payload2.limit, limit = _action$payload2$limi === void 0 ? _constants.PER_PAGE_CHALLENGES_LIST : _action$payload2$limi, language = _action$payload2.language, defaultLanguage = _action$payload2.defaultLanguage, search = _action$payload2.search;
          _context3.prev = 1;
          _context3.next = 4;
          return gatherChallengeList({
            apis: apis,
            clientId: clientId,
            status: 'current',
            skip: skip,
            limit: limit,
            search: search
          });

        case 4:
          _yield$gatherChalleng2 = _context3.sent;
          data = _yield$gatherChalleng2.data;
          meta = _yield$gatherChalleng2.meta;
          convertedData = data.map(function (item) {
            if (item.display) {
              return _objectSpread({}, item, {
                display: _olyEngineUtils.displayUtils.getDisplayObjectValues({
                  display: item.display,
                  language: language,
                  defaultLanguage: defaultLanguage
                })
              });
            }

            return item;
          });
          _context3.next = 10;
          return (0, _effects.put)(_actions["default"].loadCurrentChallengesSuccess({
            data: convertedData,
            meta: meta
          }));

        case 10:
          _context3.next = 16;
          break;

        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 16;
          return (0, _effects.put)(_actions["default"].loadCurrentChallengesError(true));

        case 16:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 12]]);
}

function loadNextChallenges(apis, action) {
  var _action$payload3, clientId, _action$payload3$skip, skip, _action$payload3$limi, limit, language, defaultLanguage, search, _yield$gatherChalleng3, data, meta, convertedData;

  return _regenerator["default"].wrap(function loadNextChallenges$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _action$payload3 = action.payload, clientId = _action$payload3.clientId, _action$payload3$skip = _action$payload3.skip, skip = _action$payload3$skip === void 0 ? 0 : _action$payload3$skip, _action$payload3$limi = _action$payload3.limit, limit = _action$payload3$limi === void 0 ? _constants.PER_PAGE_CHALLENGES_LIST : _action$payload3$limi, language = _action$payload3.language, defaultLanguage = _action$payload3.defaultLanguage, search = _action$payload3.search;
          _context4.prev = 1;
          _context4.next = 4;
          return gatherChallengeList({
            apis: apis,
            clientId: clientId,
            status: 'next',
            skip: skip,
            limit: limit,
            search: search
          });

        case 4:
          _yield$gatherChalleng3 = _context4.sent;
          data = _yield$gatherChalleng3.data;
          meta = _yield$gatherChalleng3.meta;
          convertedData = data.map(function (item) {
            if (item.display) {
              return _objectSpread({}, item, {
                display: _olyEngineUtils.displayUtils.getDisplayObjectValues({
                  display: item.display,
                  language: language,
                  defaultLanguage: defaultLanguage
                })
              });
            }

            return item;
          });
          _context4.next = 10;
          return (0, _effects.put)(_actions["default"].loadNextChallengesSuccess({
            data: convertedData,
            meta: meta
          }));

        case 10:
          _context4.next = 16;
          break;

        case 12:
          _context4.prev = 12;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 16;
          return (0, _effects.put)(_actions["default"].loadNextChallengesError(true));

        case 16:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 12]]);
}

function loadFinishedChallenges(apis, action) {
  var _action$payload4, clientId, _action$payload4$skip, skip, _action$payload4$limi, limit, language, defaultLanguage, search, _yield$gatherChalleng4, data, meta, convertedData;

  return _regenerator["default"].wrap(function loadFinishedChallenges$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _action$payload4 = action.payload, clientId = _action$payload4.clientId, _action$payload4$skip = _action$payload4.skip, skip = _action$payload4$skip === void 0 ? 0 : _action$payload4$skip, _action$payload4$limi = _action$payload4.limit, limit = _action$payload4$limi === void 0 ? _constants.PER_PAGE_CHALLENGES_LIST : _action$payload4$limi, language = _action$payload4.language, defaultLanguage = _action$payload4.defaultLanguage, search = _action$payload4.search;
          _context5.prev = 1;
          _context5.next = 4;
          return gatherChallengeList({
            apis: apis,
            clientId: clientId,
            status: 'finish',
            skip: skip,
            limit: limit,
            search: search
          });

        case 4:
          _yield$gatherChalleng4 = _context5.sent;
          data = _yield$gatherChalleng4.data;
          meta = _yield$gatherChalleng4.meta;
          convertedData = data.map(function (item) {
            if (item.display) {
              return _objectSpread({}, item, {
                display: _olyEngineUtils.displayUtils.getDisplayObjectValues({
                  display: item.display,
                  language: language,
                  defaultLanguage: defaultLanguage
                })
              });
            }

            return item;
          });
          _context5.next = 10;
          return (0, _effects.put)(_actions["default"].loadFinishedChallengesSuccess({
            data: convertedData,
            meta: meta
          }));

        case 10:
          _context5.next = 16;
          break;

        case 12:
          _context5.prev = 12;
          _context5.t0 = _context5["catch"](1);
          _context5.next = 16;
          return (0, _effects.put)(_actions["default"].loadFinishedChallengesError(true));

        case 16:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[1, 12]]);
}

function loadRegisteredCurrentChallenges(apis, action) {
  var _action$payload5, clientId, userId, _action$payload5$skip, skip, _action$payload5$limi, limit, language, defaultLanguage, _yield$apis$userCoreA, data, meta, convertedData;

  return _regenerator["default"].wrap(function loadRegisteredCurrentChallenges$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _action$payload5 = action.payload, clientId = _action$payload5.clientId, userId = _action$payload5.userId, _action$payload5$skip = _action$payload5.skip, skip = _action$payload5$skip === void 0 ? 0 : _action$payload5$skip, _action$payload5$limi = _action$payload5.limit, limit = _action$payload5$limi === void 0 ? _constants.PER_PAGE_CHALLENGES_LIST : _action$payload5$limi, language = _action$payload5.language, defaultLanguage = _action$payload5.defaultLanguage;
          _context6.prev = 1;
          _context6.next = 4;
          return apis.userCoreApi.getUserRegisteredChallengesNew({
            clientId: clientId,
            status: 'active',
            userId: userId,
            skip: skip,
            limit: limit
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _yield$apis$userCoreA = _context6.sent;
          data = _yield$apis$userCoreA.data;
          meta = _yield$apis$userCoreA.meta;
          convertedData = data.map(function (item) {
            if (item.display) {
              return _objectSpread({}, item, {
                display: _olyEngineUtils.displayUtils.getDisplayObjectValues({
                  display: item.display,
                  language: language,
                  defaultLanguage: defaultLanguage
                })
              });
            }

            return item;
          });
          _context6.next = 10;
          return (0, _effects.put)(_actions["default"].loadRegisteredCurrentChallengesSuccess({
            data: convertedData,
            meta: meta
          }));

        case 10:
          _context6.next = 16;
          break;

        case 12:
          _context6.prev = 12;
          _context6.t0 = _context6["catch"](1);
          _context6.next = 16;
          return (0, _effects.put)(_actions["default"].loadRegisteredCurrentChallengesError(true));

        case 16:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6, null, [[1, 12]]);
}

function loadRegisteredFinishedChallenges(apis, action) {
  var _action$payload6, clientId, userId, _action$payload6$skip, skip, _action$payload6$limi, limit, language, defaultLanguage, _yield$apis$userCoreA2, data, meta, convertedData;

  return _regenerator["default"].wrap(function loadRegisteredFinishedChallenges$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _action$payload6 = action.payload, clientId = _action$payload6.clientId, userId = _action$payload6.userId, _action$payload6$skip = _action$payload6.skip, skip = _action$payload6$skip === void 0 ? 0 : _action$payload6$skip, _action$payload6$limi = _action$payload6.limit, limit = _action$payload6$limi === void 0 ? _constants.PER_PAGE_CHALLENGES_LIST : _action$payload6$limi, language = _action$payload6.language, defaultLanguage = _action$payload6.defaultLanguage;
          _context7.prev = 1;
          _context7.next = 4;
          return apis.userCoreApi.getUserRegisteredChallengesNew({
            clientId: clientId,
            status: 'finish',
            userId: userId,
            skip: skip,
            limit: limit
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _yield$apis$userCoreA2 = _context7.sent;
          data = _yield$apis$userCoreA2.data;
          meta = _yield$apis$userCoreA2.meta;
          convertedData = data.map(function (item) {
            if (item.display) {
              return _objectSpread({}, item, {
                display: _olyEngineUtils.displayUtils.getDisplayObjectValues({
                  display: item.display,
                  language: language,
                  defaultLanguage: defaultLanguage
                })
              });
            }

            return item;
          });
          _context7.next = 10;
          return (0, _effects.put)(_actions["default"].loadRegisteredFinishedChallengesSuccess({
            data: convertedData,
            meta: meta
          }));

        case 10:
          _context7.next = 16;
          break;

        case 12:
          _context7.prev = 12;
          _context7.t0 = _context7["catch"](1);
          _context7.next = 16;
          return (0, _effects.put)(_actions["default"].loadRegisteredFinishedChallengesError(true));

        case 16:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7, null, [[1, 12]]);
}

function loadPromoteChallenges(apis, action) {
  var _action$payload7, clientId, language, defaultLanguage, _yield$gatherChalleng5, data, meta, convertedData;

  return _regenerator["default"].wrap(function loadPromoteChallenges$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _action$payload7 = action.payload, clientId = _action$payload7.clientId, language = _action$payload7.language, defaultLanguage = _action$payload7.defaultLanguage;
          _context8.prev = 1;
          _context8.next = 4;
          return gatherChallengeList({
            apis: apis,
            clientId: clientId,
            status: 'promote'
          });

        case 4:
          _yield$gatherChalleng5 = _context8.sent;
          data = _yield$gatherChalleng5.data;
          meta = _yield$gatherChalleng5.meta;
          convertedData = data.map(function (item) {
            if (item.display) {
              return _objectSpread({}, item, {
                display: _olyEngineUtils.displayUtils.getDisplayObjectValues({
                  display: item.display,
                  language: language,
                  defaultLanguage: defaultLanguage
                })
              });
            }

            return item;
          });
          _context8.next = 10;
          return (0, _effects.put)(_actions["default"].loadPromoteChallengesSuccess({
            data: convertedData,
            meta: meta
          }));

        case 10:
          _context8.next = 16;
          break;

        case 12:
          _context8.prev = 12;
          _context8.t0 = _context8["catch"](1);
          _context8.next = 16;
          return (0, _effects.put)(_actions["default"].loadPromoteChallengesError(true));

        case 16:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8, null, [[1, 12]]);
}

function watchLoadActiveChallenges(apis) {
  return _regenerator["default"].wrap(function watchLoadActiveChallenges$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeLeading)((0, _utils.getType)(_actions["default"].loadActiveChallenges), loadActiveChallenges, apis);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

function watchLoadCurrentChallenges(apis) {
  return _regenerator["default"].wrap(function watchLoadCurrentChallenges$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadCurrentChallenges), loadCurrentChallenges, apis);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}

function watchLoadNextChallenges(apis) {
  return _regenerator["default"].wrap(function watchLoadNextChallenges$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadNextChallenges), loadNextChallenges, apis);

        case 2:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11);
}

function watchLoadFinishedChallenges(apis) {
  return _regenerator["default"].wrap(function watchLoadFinishedChallenges$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadFinishedChallenges), loadFinishedChallenges, apis);

        case 2:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12);
}

function watchLoadRegisteredCurrentChallenges(apis) {
  return _regenerator["default"].wrap(function watchLoadRegisteredCurrentChallenges$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.takeLeading)((0, _utils.getType)(_actions["default"].loadRegisteredCurrentChallenges), loadRegisteredCurrentChallenges, apis);

        case 2:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13);
}

function watchLoadRegisteredFinishedChallenges(apis) {
  return _regenerator["default"].wrap(function watchLoadRegisteredFinishedChallenges$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadRegisteredFinishedChallenges), loadRegisteredFinishedChallenges, apis);

        case 2:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked14);
}

function watchLoadPromoteChallenges(apis) {
  return _regenerator["default"].wrap(function watchLoadPromoteChallenges$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadPromoteChallenges), loadPromoteChallenges, apis);

        case 2:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked15);
}

var challengesSagas = function challengesSagas(apis) {
  return [(0, _effects.fork)(watchLoadActiveChallenges, apis), (0, _effects.fork)(watchLoadCurrentChallenges, apis), (0, _effects.fork)(watchLoadNextChallenges, apis), (0, _effects.fork)(watchLoadFinishedChallenges, apis), (0, _effects.fork)(watchLoadRegisteredCurrentChallenges, apis), (0, _effects.fork)(watchLoadRegisteredFinishedChallenges, apis), (0, _effects.fork)(watchLoadPromoteChallenges, apis)];
};

exports.challengesSagas = challengesSagas;
var _default = challengesSagas;
exports["default"] = _default;
//# sourceMappingURL=sagas.js.map